export default "__VITE_ASSET__B4Bbbp0J__"